
<template>
  <div>
    <div class="form-frame" :class="computedClass">
      <b-row>
        <b-col align="right">หน้า 3/3</b-col>
      </b-row>
      <!--        No -->
      <b-row class="row">
        <b-row>
          <b-col sm="4" md="4" align="left" style="padding-left: 30px">เลขที่ชันสูตร</b-col>
          <!--                    <b-col sm="5" md="5">-->
          <b-col>
            <input class="custom-input" type="text" style="background: #F2F2F2" readonly="true" v-model="case_id">
          </b-col>
        </b-row>
      </b-row>
      <div class="my-md-4" style="border-top: 1px solid #636b6f;">
      </div>
      <div class="my-md-4" style="padding-top: 1em; text-align: center">
        <span class="font22 font-title-color">แบบบันทึกบาดแผล</span>
      </div>
      <div id="wrapperCanvas">
        <div id="drawCanvas" >
          <img class="img-bg" style="width: 100%; "
               src="../../assets/dead-diagram.png">

          <table id="cell1000" cellspacing="0" cellpadding="0" >
            <tr v-for="(row, y ) in tableCell">
              <td v-for="(value, x) in row" v-on:click="editPoint(x,y,value)"  class="cellDraw">
                <div v-if="tableCell[y][x].type != 0"

                     v-bind:class="[ tableCell[y][x].type > 0 ? 'activeCell' : '', 'divCell']">
                  {{tableCell[y][x].index}}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>



      <b-row class="row" style="padding: 2em" >
        <b-col cols="12" lg="12" md="6" sm="6" style="text-align: center">
          <span class="font22 font-title-color">รายการบาดแผล</span>
        </b-col>
        <table class="table border-detail table-responsive-sm table-hover" style="width: 100%; ">
          <tr style="text-align: center">
            <th width="50px">
              ลำดับ
            </th>
            <th width="40%">
              ตำแหน่งบาดแผล
            </th>
            <th>
              ชนิดบาดแผล
            </th>
            <th>
              รูปบาดแผล
            </th>
          </tr>
          <tbody v-for="(value,i) in injuryForm" :key="i" style="font-weight: normal">
          <!--          @click="editPoint(value.x,value.y)"-->
<!--          <tr v-if="'type' in value && value.type > 0" @click="editData(value )">-->
          <tr v-if="value.type > 0" @click="editData(value)">
            <td>
              {{ value.index }}
            </td>
            <td>
              {{ value.name }}
            </td>
            <td>
              {{ value.typeName }}
            </td>
            <td style="text-align: center">
              <b-img v-if="value.image_Injury && value.image_Injury != null && value.image_Injury !=''" :src="value.image_Injury"  width="200px" height="100px"></b-img>
            </td>

          </tr>
          </tbody>

        </table>

      </b-row>
      <b-col>
        <div lg="4" md="4" sm="4" cols="12" align="center">
          3/3
        </div>
      </b-col>
      <b-row>

        <b-col lg="6" md="6" sm="6" cols="6" align="left">
          <b-button class="autopsy-button" @click="goToBackPage"> <b-icon icon="arrow-left-square"></b-icon> ย้อนกลับ </b-button>

        </b-col>

        <b-col lg="6" md="6" sm="6" cols="6" align="right">
<!--          <b-button class="autopsy-button" @click="goToNextPage"> หน้าถัดไป > </b-button>-->
        </b-col>


      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="4"></b-col>
        <b-col lg="4" md="4" sm="4" >
          <b-button style="width:100%" class="autopsy-button" @click="goToHomePage()">เสร็จสิ้น</b-button>
        </b-col>
      </b-row>
    </div>


    <b-modal
            id="modal-injury-add"
            ref="modal"
            title="กรุณากรอกรายละเอียดบาดแผล"
            @hidden="resetModal"
            @ok="handleSaveInjury(true)"
            ok-title="บันทึก"
            cancel-title="ยกเลิก"
            :ok-disabled="!this.selectInjury.type||!selectInjury.name">
      <form ref="form" @submit.stop.prevent="handleSaveInjury(true)">
        <b-col cols="12" sm="12" lg="12" md="12">
          <b-form-group
                  label="ตำแหน่งของแผล"
                  label-for="location-injury">
            <b-form-input
                    id="location-injury"
                    v-model="selectInjury.name"
                    required
            ></b-form-input>
          </b-form-group>
          <p class="text-left text-danger" v-if="selectInjury.type && !selectInjury.name">โปรดระบุตำแหน่งของแผล</p>

        </b-col>
        <b-col cols="12" sm="12" lg="12" md="12">
           <span v-if="!this.selectInjury.type && selectInjury.name">
              <p style="color: red">โปรดระบุชนิดบาดแผล</p>
            </span>
          <b-row style="padding-left: 15px">
            <b-form-radio-group  v-model="selectInjury.type">
              <!--              <label class="radio-label"  >-->
              <!--                <b-form-radio class="radio-300" value="0" >ไม่มีบาดแผล</b-form-radio>-->
              <!--              </label>-->

              <label class="radio-label"  :key="type.id" v-for="type in this.optionInjurytype">
                <b-form-radio class="radio-300" :value="type.id" v-model="other_injuryTypeCheck" >{{type.id}} {{type.name}}</b-form-radio>
              </label>
              <div v-if="selectInjury.type === 7">
                <b-input class="d-inline custom-input other_note_350" v-model="other_injuryType" type="text"></b-input>
              </div>
            </b-form-radio-group>
            <b-form-group
                    label="รูปบาดแผล"
                    label-for="image-input">
              <div class="d-flex mb-3">
                <b-form-file v-model="image" accept="image/*" placeholder="เพิ่มรูป" class="w-auto flex-grow-1"></b-form-file>
                <b-button v-if="hasImage" variant="danger" class="ml-3" @click="clearImage">ลบรูปภาพ</b-button>
              </div>

              <b-img v-if="hasImage" :src="imageSrc" center style="max-width: 200px;max-height: 150px " class="mb-3"  @click="modalShow = !modalShow" fluid block rounded></b-img>
              <b-modal v-model="modalShow" hide-footer  header-text-variant="danger"  header-close-content="ปิด(X)"  size="100%" centered >
                <b-img :src="imageSrc" style="max-width: 100%"></b-img>
              </b-modal>
            </b-form-group>
          </b-row>
        </b-col>
      </form>
    </b-modal>
  </div>
</template>
<script>
  import {mapState} from "vuex";
  import {domain_img_evidence} from "@/util/Constants";
  // import TraumaSelect from "../TraumaSelect";
  // import AreaSelect from "../AreaSelect";
  const base64Encode = data =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          });
  export default {
    name: "form3",
    async created() {
      await this.$store.dispatch("Eventform/onGetCaseSituation");
      await this.$store.dispatch("Eventform/onGetCaseHospital");
      this.path_image = domain_img_evidence;
      this.$swal.close();
      this.$store.dispatch("Injury/setInjurytype");
      // this.$store.dispatch("Eventform/getInjuryData", this.form.id);
      this.$store.dispatch("Eventform/getInjuryData", this.form.id)
              .then(()=>{
                console.log('this.injuryForm', this.injuryForm)
                for (let item of this.injuryForm) {
                  console.log("value is ", item);
                  // this.selectInjury = injuryData;
                  this.tableCell[item.y][item.x] = item;
                  // this.handleSaveInjury(false);
                }

                this.injuryList = this.injuryForm;
              });
    },
    data() {
      return {
        other_injuryTypeCheck:false,
        other_injuryType:'',
        path_image : null,
        case_id: '',
        tableCell: null,
        //table
        tempSelect:{
          name:'',
          type:'',
          typeName:'',
          index:'',
          x:'',
          y:'',
          image_Injury: null,
        },
        selectInjury:{
          name:'',
          type:'',
          typeName:'',
          index:null,
          x:'',
          y:'',
          image_Injury: null,
        },
        injuryList:[],
        image:null,
        imageSrc: null,
        isAdding: true,
        modalShow: false,
      }
    },
    computed: {
      ...mapState({
        username:state => state.Auth.username,
        startLocation: state => {
          return state.Event.startLocation;
        },
        optionInjurytype: state => {
          return state.Injury.injury_type;
        },
        optionInjuryarea: state => {
          return state.Injury.injury_area;
        },
        form: state => {
          return state.Eventform.form;
        },
        injuryForm: state => {
          return state.Eventform.injuryForm;
        },
        computedClass(){
          let classStyle = this.form.event_type;
          if (classStyle == '1') {
            classStyle = "bgType1";
          }else if (classStyle == '2'){
            classStyle = "bgType2";
          }
          return classStyle;
        },
        hasImage() {
          return (this.imageSrc);
        },
      })
    },
    watch: {
      image(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            base64Encode(newValue)
                    .then(value => {
                      this.imageSrc = value;
                    })
                    .catch(() => {
                      this.imageSrc = null;
                    });
          } else {
            this.imageSrc = null;
          }
        }
      },
    },
    mounted() {
      // Total Cell == 50W * 70H = 3,500 Cell
      this.tableCell = this.newTable(20,40,0);
      console.log("mounted",this.form);
      this.case_id = this.form.case_id;
      this.$store.dispatch("Eventform/getInjuryData", this.form.id)
              .then(()=>{
                console.log('this.injuryForm', this.injuryForm)
                for (let item of this.injuryForm) {
                  console.log("value is ", item);
                  // this.selectInjury = injuryData;
                  this.tableCell[item.y][item.x] = item;
                  // this.handleSaveInjury(false);
                }

                this.injuryList = this.injuryForm;
              });

    },

    methods: {
      clearImage() {
        this.image = null;
        this.imageSrc= null;
      },
      newTable(w, h, val){
        var arr = [];
        for(let y = 0; y < h; y++) {
          arr[y] = [];
          for(let x = 0; x < w; x++) {
            var injuryOBJ = {
              name:'',
              type:'',
              typeName:'',
              index:'',
              x:x,
              y:y,
            }
            arr[y][x] = injuryOBJ
          }
        }
        return arr;
      },
      editPoint(x,y,value){
        // this.selectInjury = JSON.parse(JSON.stringify(this.tempSelect));
        console.log("value",value)
        console.log("add[x][y]", this.tableCell[y][x])
        this.selectInjury.x = value.x;
        this.selectInjury.y = value.y;
        this.selectInjury.name = value.name
        this.selectInjury.type = value.type
        this.selectInjury.index = value.index
        if(this.selectInjury.type === 7){

          this.other_injuryType = value.typeName
        }

        // console.log("edit[x][y]", this.tableCell[itemX][itemY])
        if (value.image_Injury){
          this.imageSrc = value.image_Injury
        }else {
          this.imageSrc= null
        }
        console.log( "edit", this.selectInjury)
        // this.$bvModal.show("modal-injury-edit")
        this.$bvModal.show("modal-injury-add")
        if (this.tableCell[y][x].image_Injury){
          this.imageSrc = this.tableCell[y][x].image_Injury
        }else {
          this.imageSrc= null
        }
        // this.selectInjury.image_Injury = this.tableCell[y][x].image_Injury ;
        // alert("this.selectInjury.image_Injury",this.selectInjury.image_Injury)
        console.log("add", this.selectInjury)
        this.$bvModal.show("modal-injury-add")
      },
      editData(value ){
        this.selectInjury.index = value.index
        this.selectInjury.x = value.x;
        this.selectInjury.y = value.y;
        this.selectInjury.name = value.name
        this.selectInjury.type = value.type

        if(this.selectInjury.type === 7){

          this.other_injuryType = value.typeName
        }

        // console.log("edit[x][y]", this.tableCell[itemX][itemY])
        if (value.image_Injury){
          this.imageSrc = value.image_Injury
        }else {
          this.imageSrc= null
        }
        console.log( "edit", this.selectInjury)
        // this.$bvModal.show("modal-injury-edit")
        this.$bvModal.show("modal-injury-add")
      },
      handleSaveInjury(isSave){
        console.log('handleSaveInjury : ', this.selectInjury)
        console.log("this.injuryList1",this.injuryList)
        if (this.imageSrc != null && this.imageSrc !='' || this.image != null && this.image !=''){
          this.selectInjury.image_Injury = this.imageSrc;
        } else {
          this.selectInjury.image_Injury = null
        }

        var x = this.selectInjury.x;
        var y = this.selectInjury.y;
        var injuryTypeName;
        if (this.selectInjury.type === 7){
          if (this.other_injuryType || this.other_injuryType !== '') {
            injuryTypeName = this.other_injuryType
          }
        } else {
          injuryTypeName = this.getInjuryTypeName(this.selectInjury.type);
        }

        if(this.selectInjury){
          this.tableCell[y][x].name =this.selectInjury.name
          this.tableCell[y][x].type =this.selectInjury.type
          this.tableCell[y][x].typeName = injuryTypeName
          this.tableCell[y][x].image_Injury = this.selectInjury.image_Injury
          this.tableCell[y][x].isUpdate = true

          if (!this.selectInjury.index) {
            let injuryIndex = this.injuryList.length+1;
            this.tableCell[y][x].index = injuryIndex
            console.log('push...')
            this.injuryList.push(this.tableCell[y][x])
          }

          console.log("this.injuryList2",this.injuryList)
          this.$forceUpdate();
          if (isSave === true){
            this.saveInjuryData();
          }else {
            this.resetModal()
          }
        }else {
          this.resetModal()
        }

      },
      async  saveInjuryData(){
        let data = {};
        console.log("saveInjuryData",this.form.id)
        data['id'] = this.form.id;
        data['data'] = JSON.stringify(this.injuryList);
        console.log("data",data)
        await this.$store.dispatch("Eventform/postInjuryData", data)
        this.resetModal();
      },
      resetModal(){
        this.selectInjury={
          name:'',
          type:'',
          typeName:'',
          index:null,
          x:'',
          y:'',
          image_Injury: null,
        }
        this.other_injuryTypeCheck = false;
        this.other_injuryType=null;
        this.image = null;
        this.imageSrc = null;
      },
      getInjuryTypeName(type){
        var name = '';
        for (const injury of this.optionInjurytype) {
          if (injury.id === type) {
            name = injury.name
            break;
          }
        }
        return name;
      },
      goToBackPage() {
        const path = `/question-form/2`
        if (this.$route.path !== path) this.$router.push(path)
      },
      goToHomePage() {
        const path = `/home`
        if (this.$route.path !== path) this.$router.push(path)
      },
    }
  }
</script>

<style>
@media only screen and (max-width: 499px) {
  .autopsy-button{
    font-size: 14px;
    /*width: 80%;*/
    /*margin: 20px 20px 5px 5px ;*/
  }
}

  .border-detail table {
    width: 640px;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .border-detail th { background: #2DA1A9; color: #fff }
  .border-detail td, th { border: 1px solid #2DA1A9; }

  .divCell{
    font-size: 5px; line-height: 5px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .activeCell{
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #73AD21;
    font-weight: bold;
    color: white;
    background-color: tomato;
    margin: -5px;
  }
  .cellDraw{
    width: 1%; height: 1%; position: relative; padding: 0px; margin: 0px;
  }

  .radio-300{
    min-width: 220px;
    margin-right:1em;
  }


  #modal-injury-add{
    /*display: flex !important;*/
    align-items: center !important;
    justify-content: center !important;

    display: block !important;
  }
  .row {
    padding: 0.5rem 0;
  }

  #wrapperCanvas{
    width: 100%;
    text-align: center;
    background-color: #E8E8E8;
  }

  #drawCanvas{
    display: inline-block;
    position: relative;
    width:  70vw;
    height: calc(70vw * 1.4574898);
    /*margin-left: -1em;*/
    max-width: 988px;
    max-height: 1440px;

  }

  #cell1000{
    position: absolute;
    padding: 0px;
    margin: 0px;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  .img-bg{
    position: absolute;
    padding: 0px;
    margin: 0px;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  @media only screen and (max-width: 767px) {
    .img-pad {
      padding: 1em 0;
    }
  }

  .bgType1{
    background: #e6eeff;
  }
  .bgType2{
    background: #fcdcc0;
  }
</style>
